import { render, staticRenderFns } from "./pesoParaLaTallaNinas0a2A.vue?vue&type=template&id=1eebe3b0&scoped=true&"
import script from "./pesoParaLaTallaNinas0a2A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaTallaNinas0a2A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaTallaNinas0a2A.vue?vue&type=style&index=0&id=1eebe3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebe3b0",
  null
  
)

export default component.exports